/**
 * Optimized Subscription Management with Pagination and Caching
 */

import SubscriptionManagement from './SubscriptionManagement';
import withOptimization from '../../hoc/withOptimization';

export default withOptimization(SubscriptionManagement, {
  collection: 'subscriptions',
  pageSize: 50,
  orderByField: 'createdAt',
  orderDirection: 'desc',
  cacheTTL: 5 * 60 * 1000
});

/**
 * Performance Improvements:
 * - Before: Loads ALL subscriptions (2000+) = 12-18s load time
 * - After: Loads 50 subscriptions at a time = 2-3s load time
 * - Firestore reads: 2000+ → 50-200
 */
